import { cn } from '@/lib/utils';

type Props = {
  labels: string[];
  uppercase?: boolean;
  className?: string;
  /**
   * When true (default) each tag renders with a `#d9d9d9` 1px border. Callers
   * that want the tags to sit as flat pills on a light surface (e.g. the
   * `includesList` variant of ServiceListAccordion) opt out with `bordered={false}`.
   */
  bordered?: boolean;
};

export function TagList({
  labels,
  uppercase = false,
  className,
  bordered = true,
}: Props) {
  if (labels.length === 0) {
    return null;
  }

  return (
    <div className={cn('flex w-full flex-wrap gap-2', className)}>
      {labels.map((label, index) => (
        <span
          key={`${label}-${index}`}
          className={cn(
            'rounded-[5px] bg-white px-4 py-2 text-center text-[14px] font-normal leading-[1.2] text-black',
            bordered && 'border border-[#d9d9d9]',
            uppercase && 'uppercase',
          )}
        >
          {label}
        </span>
      ))}
    </div>
  );
}
